/**
 * Back Button Component
 * Rocket-themed back navigation button
 */

import { useNavigate, useLocation } from 'react-router-dom'

export default function BackButton() {
  const navigate = useNavigate()
  const location = useLocation()

  // Don't show back button on home page
  if (location.pathname === '/') {
    return null
  }

  // Define navigation hierarchy
  const getBackPath = () => {
    // All pages go back to home
    return '/'
  }

  const handleBack = () => {
    navigate(getBackPath())
  }

  return (
    <button
      className="back-button"
      onClick={handleBack}
      aria-label="Go back"
    >
      <img
        src="/images/icons/rocket.gif"
        className="back-button__icon"
        alt=""
      />
      <span className="back-button__text">Back</span>
    </button>
  )
}
